<template>
  <div ref="container">
    <slot />
  </div>
</template>

<script>
/**
 * infinite 로딩을 위한 컴포넌트 입니다.
 */
export default {
  name: "IntersectionDetector",
  mounted() {
    this.$io.observe(this.$refs.container, this.callback)
  },
  beforeDestroy() {
    this.$io.unobserve(this.$refs.container)
  },
  methods: {
    /**
     * infinity 조건 발동
     * @param entry
     * @param observer
     */
    callback(entry, observer) {
      if (!entry.isIntersecting) {
        return
      }
      this.$emit('intersect', entry.intersectionRatio)
    }
  }
}
</script>
